import Vue from 'vue';
import {
  clone, cloneDeep, orderBy, findIndex,
} from 'lodash';
import api from 'src/api';

// в константы выносим только названия мутаций,
// которые переиспользуем/планируем переиспользовать
export const SET_FETCHING = 'SET_FETCHING';
export const SET_STOP_FETCHING = 'SET_STOP_FETCHING';

const msToMin = 60000;

const data = {
  magnets: [],
  fething: false,
};

const actions = {
  fetchMagnets({ commit }) {
    commit(SET_FETCHING);
    return api.getMagnets().then((res) => {
      const parseRes = res.map((item) => {
        const parseMagnets = cloneDeep(item);
        if (parseMagnets.magnetTimeout) parseMagnets.magnetTimeout /= msToMin;
        if (!parseMagnets.magnetTimeout) parseMagnets.magnetTimeout = null;
        return ({
          ...parseMagnets,
        });
      });
      commit('SYNC', parseRes);
    })
      .catch((err) => {
        commit(SET_STOP_FETCHING);
        throw err;
      });
  },
  createMagnet({ commit }, { model }) {
    const parseMagnets = cloneDeep(model);
    if (parseMagnets.magnetTimeout) parseMagnets.magnetTimeout *= msToMin;
    if (!parseMagnets.magnetTimeout) parseMagnets.magnetTimeout = null;
    const parseModel = ({
      ...parseMagnets,
    });
    return api.createMagnet(parseModel).then((res) => {
      commit('ADD_MAGNET', res);
    });
  },
  updateMagnet({ commit }, { id, model }) {
    const parseMagnets = cloneDeep(model);
    if (parseMagnets.magnetTimeout) parseMagnets.magnetTimeout *= msToMin;
    if (!parseMagnets.magnetTimeout) parseMagnets.magnetTimeout = null;
    const parseModel = ({
      ...parseMagnets,
    });
    return api.updateMagnet(id, parseModel).then((res) => {
      commit('UPDATE_MAGNET', res);
    });
  },
  deleteMagnet({ commit }, id) {
    commit(SET_FETCHING);
    return api.deleteMagnet(id)
      .then(() => commit('DELETE_MAGNET', id))
      .catch((err) => {
        commit(SET_STOP_FETCHING);
        throw err;
      });
  },
};

const mutations = {
  SET_FETCHING(state) {
    state.fetching = true;
  },
  SET_STOP_FETCHING(state) {
    state.fetching = false;
  },
  SYNC(state, payload) {
    state.magnets = cloneDeep(orderBy(payload, 'name'));
    mutations.SET_STOP_FETCHING(state);
  },
  UPDATE_MAGNET(state, res) {
    const { id } = res;
    const { magnets } = state;
    const index = findIndex(magnets, { id });
    Vue.set(magnets, index, { ...magnets[index], ...res });
  },
  DELETE_MAGNET(state, id) {
    const { magnets } = state;
    Vue.delete(magnets, findIndex(magnets, { id }));
  },
  ADD_MAGNET(state, res) {
    state.magnets.push(clone(res));
  },
};

const getters = {
  getMagnet(state) {
    const { magnets } = state;
    return (id) => (magnets[findIndex(magnets, { id })]);
  },
};

const store = {
  namespaced: true,
  state: data,
  mutations,
  getters,
  actions,
};

export default store;
